module.exports = __webpack_public_path__ + "img/icon_ai_news@3x.3b1eb148.png";